import { observer } from 'mobx-react-lite';
import React from 'react'
import { Button, Divider, Grid, Header, Item, Reveal, Segment, Statistic } from 'semantic-ui-react';
import { UserActivity } from '../../app/models/userActivity';
import FollowTaglleButton from './FollowTaglleButton';

interface Props {
   profile: UserActivity;
}

function ProfileHeader(props : Props) {
    return (
        <Segment>
            <Grid>
                <Grid.Column width='12'> 
                    <Item.Group>
                        <Item>
                            {/* <Item.Image src={`/assets/user.png`} size='small' avatar /> */}
                            <Item.Image src={props.profile.photoUrl || `/assets/user.png`} size='small' avatar />
                            <Item.Content verticalAlign='middle' >
                                {/* <Header as='h1' content='Displayname' /> */}
                                <Header as='h1' content={props.profile.displayName} />
                            </Item.Content>
                        </Item>
                    </Item.Group>
                </Grid.Column>
                <Grid.Column width='4' > 
                    <Statistic.Group width='2' >
                        <Statistic label='Followers' value={props.profile.followersCount + 50} />
                        <Statistic label='Following' value={props.profile.followingCount + 40} />
                    </Statistic.Group>
                    <Divider />

                    {/* <Reveal animated='move' >
                        <Reveal.Content visible style={{width: '100%'}} >
                            <Button content='Following' color='teal' fluid  />
                        </Reveal.Content>
                        <Reveal.Content hidden style={{width: '100%'}} >
                            <Button content={true ? 'Unfollow' : 'Follow'} color={true ? 'red' : 'green' } basic fluid  />
                        </Reveal.Content>
                    </Reveal> */}
                    <FollowTaglleButton profile={props.profile} />
                    
                </Grid.Column>
            </Grid>
        </Segment>
    )
}

export default observer(ProfileHeader);